import './index.scss'
$("#nav3").addClass("active")
import '../../assets/scripts/jquery.select.js'
$('select.select').select();


